import { gql } from '@apollo/client';

export const GET_APP_LEVEL_MODALS_DATA = gql`
  query GetApplevelModalsDataQuery {
    notificationByAuthId {
      id
      notificationType
      activeOn
      sourceObjectIds
      data {
        lockedUntil
      }
    }
    pointsTransactionByAuthIdAndType(
      transactionType: [BIRTHDAY]
      after: "0"
      sort: [{ sort: "DESC", name: "createdDateTime" }]
      first: 10000
    ) {
      edges {
        node {
          points
          transactionType
        }
      }
    }
    notificationsNCByAuthId {
      id
      type
      data
      category
      acknowledged
    }
  }
`;
